"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var FlashMessagesService = /** @class */ (function () {
    function FlashMessagesService() {
    }
    FlashMessagesService.decorators = [
        { type: core_1.Injectable },
    ];
    return FlashMessagesService;
}());
exports.FlashMessagesService = FlashMessagesService;
